import script from "./UpdatePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&setup=true&lang=js"

import "./UpdatePassword.vue?vue&type=style&index=0&id=206ddd23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206ddd23"]])

export default __exports__